import { createSlice } from '@reduxjs/toolkit';
import initialState from './logoutInitialState';
import { _setIsLogoutTiming } from './logoutAction';

export const logoutSlice = createSlice({
  name: 'delta/logout',
  initialState,
  reducers: {
    setIsLogoutTiming: _setIsLogoutTiming,
    resetIsLogout: () => initialState,
  },
});

export const { setIsLogoutTiming, resetIsLogout } = logoutSlice.actions;

export default logoutSlice.reducer;
